import { rem } from "polished";
import styled from "styled-components";

export const Image = styled.img`
  width: 100%;
  max-width: ${rem(100)};
  object-fit: cover;
  background-image: linear-gradient(45deg, #e4e6eb 25%, transparent 25%),
    linear-gradient(-45deg, #e4e6eb 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #e4e6eb 75%),
    linear-gradient(-45deg, transparent 75%, #e4e6eb 75%);
  background-size: ${rem(10)} ${rem(10)};
  background-position: 0 0, 0 ${rem(5)}, ${rem(5)} -5px, ${rem(-5)} 0;
`;
